import { render, staticRenderFns } from "./PreviewCardOverview.vue?vue&type=template&id=6815701f&scoped=true&"
import script from "./PreviewCardOverview.vue?vue&type=script&lang=js&"
export * from "./PreviewCardOverview.vue?vue&type=script&lang=js&"
import style0 from "./PreviewCardOverview.vue?vue&type=style&index=0&id=6815701f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6815701f",
  null
  
)

export default component.exports